import { Helmet } from "react-helmet-async";
import { Link } from "react-router-dom";

const NotFound = () => (
  <>
    <Helmet>
      <title>Page Not Found | SEVAA Foundation</title>
      <meta name="description" content="The requested page could not be found on the SEVAA Foundation website." />
      <meta name="robots" content="noindex, follow" />
    </Helmet>
    <main className="min-h-[60vh] flex flex-col items-center justify-center text-center px-6">
      <p className="text-sm font-black uppercase tracking-[0.2em] text-orange-600">404 Error</p>
      <h1 className="text-6xl md:text-8xl font-black text-slate-200 mt-3">404</h1>
      <p className="text-2xl font-bold text-slate-900 mt-4">This page could not be found.</p>
      <Link to="/" className="mt-7 rounded-full bg-[#0f766e] px-6 py-3 font-bold text-white">Back to Home</Link>
    </main>
  </>
);

export default NotFound;
